import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentTeam, selectCurrentUserEmpCode } from '../../Auth/authSlice';
import ProfileCard from './ProfileCard';
import { List, Stack, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetTeamQuery } from '../../Profile/profileApiSlice';
import NoTeam from './NoTeam';

const TeamList = () => {
  // const team = useSelector(selectCurrentTeam);
  // const empCode = useSelector(selectCurrentUserEmpCode);
  const { data: team, isLoading, isError } = useGetTeamQuery(useSelector(selectCurrentUserEmpCode));
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const role = pathname.split('/')[1];
  const currentPath = pathname.split('/profile/')[1]?.split('/')[1];
  if (isLoading) {
    return <Typography>Loading..</Typography>;
  }
  console.log(team?.employeeProjectDetails, 'TEAMM');
  const handleProfileClick = empCode => {
    navigate(`/home/chats/${empCode}`);
  };
  let noTeam = Boolean(team?.employeeProjectDetails?.length === 0);
  return noTeam || isError ? (
    <NoTeam />
  ) : (
    <Stack className='content' sx={{ display: 'flex', flexGrow: 1, position: 'relative', minHeight: 0, m: 0, p: 0 }}>
      <List
        className='dynamic-height-team'
        sx={{
          p: 0,
          pl: 0.65,
          overflowY: 'auto',
          height: '806px',
          border: 1,
          borderRadius: variants.boxRadius.SIDEBAR,
          borderColor: 'divider',
        }}
      >
        {team?.employeeProjectDetails.map((project, projectIndex) =>
          project?.teamMemberDetails.map((member, memberIndex) => (
            <ProfileCard
              key={`${projectIndex}-${memberIndex}`}
              content={member}
              handleProfileClick={handleProfileClick}
            />
          ))
        )}
      </List>
    </Stack>
  );
};

export default TeamList;
